import { Button } from '@grupoboticario/flora-react';
import styled from 'styled-components';
import Text from 'styles/typography';

export const Wrapper = styled.div`
  width: 100%;
  header {
    width: 100%;
    padding: 13px 0;

    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  footer {
    margin-top: 8px;
    display: flex;
    align-items: center;
    justify-content: center;

    button {
      font-size: 14px;
      font-weight: 500;
      height: 24px;
      color: ${({ theme }) => theme.colors.textLight};
    }
  }
`;

export const GridClaims = styled.div`
  display: flex;
  width: 100%;
  gap: 12px;
  flex-direction: row;
  flex-wrap: wrap;

  @media (max-width: 1110px) {
    display: flex;
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;
    height: 180px;

    > div {
      min-width: 220px;
    }
  }
`;

export const Title = styled(Text)`
  font-size: 20px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.mainDark};
`;

export const Search = styled.div`
  height: 48px;
  // width: 49%;
  min-width: 280px;
  max-width: 3720px;

  @media (max-width: 410px) {
    width: auto;
  }
`;

export const DownloadButton = styled(Button)`
  & + & {
    margin-left: 6px;
  }
  height: 48px;
  width: 48px;
  padding: 14px;

  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: 14px;
  // box-shadow: inset 0 0 0 1px ${({ theme }) => theme.colors.main};

  &.warning-ghost {
    background: ${({ theme }) => theme.colors.shape};
    color: ${({ theme }) => theme.colors.error};
    box-shadow: inset 0 0 0 1px ${({ theme }) => theme.colors.error};

    transition: background 150ms ease, box-shadow 150ms ease, color 150ms ease;

    &:hover {
      background: ${({ theme }) => theme.colors.error};
      color: ${({ theme }) => theme.colors.shape};
    }
  }
`;
